import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import UISpinner from 'Components/UIComponents/UISpinner';
import { useCurrentUserGet } from 'Hooks/User';
import { AuthStatuses } from 'Interfaces/Auth';
import { DataLayerAnalytics } from 'Services/Integrations';
import Toast from 'Services/Toast';
import { UNDER_MAINTENANCE } from 'Utils/constants';
import { isNotEmpty, redirectToUserWorkflowVersion } from 'Utils/functions';
import { selectAuthStatus } from 'Utils/selectors';

import {
  ActivateTrialRoutes,
  AuthorizedRoutes,
  UnauthorizedRoutes,
  UnderMaintenanceRoutes,
} from './Components';

function AppRouter() {
  const [isLoading, setIsLoading] = useState(false);
  const [getCurrentUser] = useCurrentUserGet();

  const authStatus = useSelector(selectAuthStatus);

  const handleCurrentUserGet = useCallback(async () => {
    try {
      setIsLoading(true);
      const user = await getCurrentUser(undefined);

      if (isNotEmpty(user) && user.id) {
        redirectToUserWorkflowVersion(user.workflowVersion);

        DataLayerAnalytics.fireUserIdEvent(user);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Toast.handleErrors(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!UNDER_MAINTENANCE) handleCurrentUserGet();
  }, [handleCurrentUserGet]);

  if (UNDER_MAINTENANCE) {
    return <RouterProvider router={UnderMaintenanceRoutes} />;
  }

  if (!isLoading && authStatus === AuthStatuses.UNAUTHORIZED) {
    return <RouterProvider router={UnauthorizedRoutes} />;
  }

  if (!isLoading && authStatus === AuthStatuses.TRIAL) {
    return <RouterProvider router={ActivateTrialRoutes} />;
  }

  if (!isLoading && authStatus === AuthStatuses.AUTHORIZED) {
    return <RouterProvider router={AuthorizedRoutes} />;
  }

  return <UISpinner width={50} height={50} wrapperClassName="spinner--main__wrapper" />;
}

export default AppRouter;
